import React from 'react'
import classes from './ColoredList.scss'

export const ColoredList = ({ titles, children }) => {
  return <ul className={[classes.list, titles && classes.titles].join(' ')}>
    {children}
  </ul>
}

export default ColoredList



/** WEBPACK FOOTER **
 ** ./src/components/Common/ColoredList/ColoredList.js
 **/